import React from "react";
import { Image } from "react-bootstrap";
import AccessRights from "utils/AccessRights";

const Columns = ({
  getActions,
  session,
}) => {
  let columns = [
    {
      id: "name",
      header: "Name",
      accessor: "name",
      sortable: true,
      searchable: true,
    },
    {
      id: "description",
      header: "Description",
      accessor: (row) => (
        <div title={row.description}>
          {row.description && row.description.length > 50
            ? `${row.description.substring(0, 50)}...`
            : row.description}
        </div>
      ),
      sortable: true,
      searchable: true,
    },
    {
      id: "actions",
      header: "Actions",
      accessor: (row) => getActions(row),
      sortable: false,
      searchable: false,
    }
  ];

  return columns;
};

export default Columns;
